//

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { DbmCluESignRunProcessParams } from '../m-esign-process.model';

@Injectable()
export class ConnectorMdESignProcessRunService {

    constructor(private httpClient: HttpClient, private apiService : ApiService) {
    }

    doRunDocumentESignProcessAction_PUPRemDocsESign(_esignParams : DbmCluESignRunProcessParams){
        return this.httpClient.post(this.apiService.endPointsPU.doRunDocumentESignProcessAction_PUPRemDocsESign, _esignParams);
    }
    
}